// Github repo cache
export const GITHUB_REPOS = 'githubRepos';
export const GITHUB_SCOPES = 'githubScopes';
export const _DATE = 'Updated';

export const BACK_TO = 'backTo';
